import { useAbsoluteTimePartialColDef } from '@customer/components/tables/cells/absolute-time/useAbsoluteTime';
import { GeofenceData } from '@customer/hooks/assets/useAssetGeofenceTableData';
import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Model = GeofenceData;

export const useAssetGeofenceColDefs = (): ColDef<Model>[] => {
  const { t } = useTranslation();

  const absoluteTimeColDef = useAbsoluteTimePartialColDef<Model>();

  const colDefs = useMemo<ColDef<Model>[]>(
    () => [
      { field: 'where', headerName: t('GeofenceInstalled') },
      { field: 'version', headerName: t('Version') },
      {
        field: 'ts',
        headerName: t('Updated'),
        ...absoluteTimeColDef,
      },
    ],
    [t, absoluteTimeColDef],
  );

  return colDefs;
};
